import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function PortalBreadcrumb({ portal = "admin", section = "Dashboard", items }) {
  const trail = items || [{ label: portal === "client" ? "Client" : "Admin", to: `/${portal}/dashboard` }, { label: section }];
  return <nav className="portal-breadcrumb" aria-label="Breadcrumb"><ol>{trail.map((item, index) => <li key={index}>
    {index > 0 && <ChevronRight size={14} aria-hidden="true" />}
    {index < trail.length - 1 && item.to ? <Link to={item.to} state={item.state}>{item.label}</Link> : <span aria-current={index === trail.length - 1 ? "page" : undefined}>{item.label}</span>}
  </li>)}</ol></nav>;
}
